import Route from '@ember/routing/route';

export default class JugendRoute extends Route {}
